<div class="row animated fadeIn fast">

    <div class="col-md-10 ">
        <div class="card">
            <div class="card-body">
                <h4 class="card-title">Perfil de usuario</h4>
                <h6 *ngIf="paramId === 'new'"
                    class="card-subtitle">Crear un nuevo usuario</h6>
                <h6 *ngIf="paramId !== 'new'"
                    class="card-subtitle">Modificar los datos de usuario</h6>

                <form class="form p-t-20"
                      [formGroup]="usuarioForm"
                      (ngSubmit)="enviar()">

                    <div class="row">

                        <div class="col-md-8">
                            <div class="row">

                                <!-- username -->
                                <div class="col-md-4">
                                    <div class="form-group"
                                         [ngClass]="{ 'has-danger': enviado && f['username'].errors }">
                                        <label class="form-control-label">Usuario</label>
                                        <div class="input-group">
                                            <div class="input-group-addon"><i class="fa-solid fa-user"></i></div>
                                            <input [readonly]="paramId !== 'new'"
                                                   type="text"
                                                   formControlName="username"
                                                   class="form-control"
                                                   trim="blur"
                                                   [ngClass]="{ 'form-control-danger': enviado && f['username'].errors }">
                                        </div>
                                        <div *ngIf="enviado && f['username'].errors"
                                             class="form-control-feedback">
                                            <div *ngIf="f['username'].errors['required']">Obligatorio</div>
                                            <div *ngIf="f['username'].errors['minlength']">Debe contener un mínimo de 4 caracteres</div>
                                            <div *ngIf="f['username'].errors['maxlength']">No puede exceder de 100 caracteres</div>
                                        </div>
                                    </div>
                                </div>

                                <!-- rol -->
                                <div class="col-md-4">
                                    <div class="form-group"
                                         [ngClass]="{ 'has-danger': enviado && f['rol'].errors }">
                                        <label class="form-control-label">Rol</label>
                                        <div class="input-group">
                                            <div class="input-group-addon"><i class="fa-solid fa-list-check"></i></div>

                                            <select [disabled]="paramId !== 'new'"
                                                    formControlName="rol"
                                                    (ngModelChange)="onRolChange()"
                                                    class="form-control"
                                                    [ngClass]="{ 'form-control-danger': enviado && f['rol'].errors }">
                                                <option *ngFor="let rol of roles"
                                                        [value]="rol.valor">
                                                    {{ rol.texto }}
                                                </option>
                                            </select>
                                        </div>
                                        <div *ngIf="enviado && f['rol'].errors"
                                             class="form-control-feedback">
                                            <div *ngIf="f['rol'].errors['required']">Obligatorio</div>
                                            <div *ngIf="usuarioForm.get('rol')?.errors?.['apiError']">{{
                                                usuarioForm.get('rol')?.errors?.['apiError'] }}</div>
                                        </div>
                                    </div>
                                </div>


                                <!-- alm_por_defecto -->
                                <div *ngIf="usuarioSrv.userdata.rol  === 'admin'"
                                     class="col-md-4">
                                    <div class="form-group"
                                         [ngClass]="{ 'has-danger': enviado && f['alm_por_defecto'].errors }">
                                        <label class="form-control-label">Almacen predeterminado</label>
                                        <div class="input-group">
                                            <div class="input-group-addon"> <i class="fa-solid fa-warehouse"></i></div>

                                            <select formControlName="alm_por_defecto"
                                                    class="form-control"
                                                    [ngClass]="{ 'form-control-danger': enviado && f['alm_por_defecto'].errors }">
                                                <option value="">Todos los almacenes</option>
                                                <option *ngFor="let alm of almacenesList"
                                                        [value]="alm.id">
                                                    {{alm.nombre}}
                                                </option>
                                            </select>
                                        </div>
                                        <div *ngIf="enviado && f['alm_por_defecto'].errors"
                                             class="form-control-feedback">
                                            <div *ngIf="usuarioForm.get('alm_por_defecto')?.errors?.['apiError']">{{
                                                usuarioForm.get('alm_por_defecto')?.errors?.['apiError'] }}</div>
                                        </div>
                                    </div>
                                </div>

                                <!-- nombre -->
                                <div class="col-md-4">
                                    <div class="form-group"
                                         [ngClass]="{ 'has-danger': enviado && f['nombre'].errors }">
                                        <label class="form-control-label">Nombre</label>
                                        <input type="text"
                                               formControlName="nombre"
                                               class="form-control"
                                               [ngClass]="{ 'form-control-danger': enviado && f['nombre'].errors }">
                                        <div *ngIf="enviado && f['nombre'].errors"
                                             class="form-control-feedback">
                                            <div *ngIf="f['nombre'].errors['required']">Obligatorio</div>
                                            <div *ngIf="f['nombre'].errors['minlength']">Debe contener un mínimo de 4 caracteres</div>
                                            <div *ngIf="f['nombre'].errors['maxlength']">No puede exceder de 150 caracteres</div>
                                            <div *ngIf="usuarioForm.get('nombre')?.errors?.['apiError']">{{usuarioForm.get('nombre')?.errors?.['apiError'] }}</div>
                                        </div>
                                    </div>
                                </div>

                                <!-- apellidos -->
                                <div class="col-md-8">
                                    <div class="form-group"
                                         [ngClass]="{ 'has-danger': enviado && f['apellidos'].errors }">
                                        <label class="form-control-label">Apellidos</label>
                                        <input type="text"
                                               formControlName="apellidos"
                                               class="form-control"
                                               [ngClass]="{ 'form-control-danger': enviado && f['apellidos'].errors }">
                                        <div *ngIf="enviado && f['apellidos'].errors"
                                             class="form-control-feedback">
                                            <div *ngIf="f['apellidos'].errors['required']">Obligatorio</div>
                                            <div *ngIf="f['apellidos'].errors['minlength']">Debe contener un mínimo de 4 caracteres</div>
                                            <div *ngIf="f['apellidos'].errors['maxlength']">No puede exceder de 150 caracteres</div>
                                            <div *ngIf="usuarioForm.get('apellidos')?.errors?.['apiError']">{{usuarioForm.get('apellidos')?.errors?.['apiError'] }}</div>
                                        </div>
                                    </div>
                                </div>


                            </div>

                        </div>

                        <!-- foto -->
                        <div class="col-md-3">
                            <label class="form-control-label ml-4 mr-1">Modificar foto </label>

                            <img [src]="fotoDir +'/users/'+ usuario.foto"
                                 loading="lazy"
                                 (click)="abrirModal(usuario)"
                                 title="Cambiar ó borrar foto"
                                 alt="Foto"
                                 class="img-thumbnail img-avatar pointer">
                        </div>


                    </div>

                    <div class="row">


                        <!-- email -->
                        <div class="col-md-8">
                            <div class="form-group"
                                 [ngClass]="{ 'has-danger': enviado && f['email'].errors }">
                                <label class="form-control-label">Email</label>
                                <input type="text"
                                       formControlName="email"
                                       class="form-control"
                                       [ngClass]="{ 'form-control-danger': enviado && f['email'].errors }">
                                <div *ngIf="enviado && f['email'].errors"
                                     class="form-control-feedback">
                                    <div *ngIf="f['email'].errors['required']">Obligatorio</div>
                                    <div *ngIf="f['email'].errors['eMailFormat']">No parece un eMail válido</div>
                                    <div *ngIf="usuarioForm.get('email')?.errors?.['apiError']">{{usuarioForm.get('email')?.errors?.['apiError'] }}</div>
                                </div>
                            </div>
                        </div>


                        <!-- telefono -->
                        <div class="col-md-4">
                            <div class="form-group"
                                 [ngClass]="{ 'has-danger': enviado && f['telefono'].errors }">
                                <label class="form-control-label">Teléfono</label>
                                <input type="text"
                                       formControlName="telefono"
                                       class="form-control"
                                       [ngClass]="{ 'form-control-danger': enviado && f['telefono'].errors }">
                                <div *ngIf="enviado && f['telefono'].errors"
                                     class="form-control-feedback">
                                    <div *ngIf="f['telefono'].errors['required']">Obligatorio</div>
                                    <div *ngIf="usuarioForm.get('telefono')?.errors?.['apiError']">{{usuarioForm.get('telefono')?.errors?.['apiError'] }}</div>
                                </div>
                            </div>
                        </div>


                    </div> <!-- row -->



                    <!-- USUARIO CLIENTE, datos de INTRANET -->


                    <div *ngIf="usuarioForm.get('rol')?.value === 'cliente'"
                         class="card border border-secondary rounded intranetCard">
                        <div class="card-body ">
                            <h4 class="card-title"><i class="fa-solid fa-user-tie"></i> Intranet de Cliente</h4>

                            <div class="row">

                                <!-- id_cliente -->
                                <div class="col-md-4">
                                    <div class="form-group"
                                         [ngClass]="{ 'has-danger': enviado && f['id_cliente'].errors }">
                                        <label class="form-control-label">Pertenece al cliente:</label>
                                        <div class="input-group">
                                            <div class="input-group-addon"> <i class="fa-solid fa-users"></i></div>

                                            <select formControlName="id_cliente"
                                                    class="form-control"
                                                    [ngClass]="{ 'form-control-danger': enviado && f['id_cliente'].errors }">
                                                <option value="">Ninguno</option>
                                                <option *ngFor="let cliente of clientesList"
                                                        [value]="cliente.id">
                                                    {{cliente.nombre}}
                                                </option>
                                            </select>
                                        </div>
                                        <div *ngIf="enviado && f['id_cliente'].errors"
                                             class="form-control-feedback">
                                            <div *ngIf="f['id_cliente'].errors['required']">Obligatorio</div>
                                            <div *ngIf="usuarioForm.get('id_cliente')?.errors?.['apiError']">{{
                                                usuarioForm.get('id_cliente')?.errors?.['apiError'] }}</div>
                                        </div>
                                    </div>
                                </div>



                                <!-- rolIntranet -->
                                <div class="col-md-4">
                                    <div class="form-group"
                                         [ngClass]="{ 'has-danger': enviado && f['rolIntranet'].errors }">
                                        <label class="form-control-label">Rol en la Intranet</label>
                                        <div class="input-group">
                                            <div class="input-group-addon"><i class="fa-solid fa-list-check"></i></div>

                                            <select formControlName="rolIntranet"
                                                    class="form-control"
                                                    [ngClass]="{ 'form-control-danger': enviado && f['rolIntranet'].errors }">
                                                <option>admin</option>
                                                <option>consultas</option>
                                            </select>
                                        </div>
                                        <div *ngIf="enviado && f['rolIntranet'].errors"
                                             class="form-control-feedback">
                                            <div *ngIf="f['rolIntranet'].errors['required']">Obligatorio</div>
                                            <div *ngIf="usuarioForm.get('rolIntranet')?.errors?.['apiError']">{{
                                                usuarioForm.get('rolIntranet')?.errors?.['apiError'] }}</div>
                                        </div>
                                    </div>
                                </div>



                                <!-- clientes_seleccionados -->
                                <div class="col-md-4">
                                    <div *ngIf="usuarioForm.get('id_cliente')?.value && paramId !== 'new'"
                                         class="form-group "
                                         [ngClass]="{ 'has-danger': enviado && f['clientes_seleccionados'].errors }">
                                        <label class="custom-control-label"
                                               for="clientes_seleccionados"
                                               data-toggle="tooltip"
                                               title="El usuario podrá seleccionar uno de estos clientes desde la intranet">
                                            Otros clientes seleccionables por el usuario
                                            <i class="ml-1 text-info fa-solid fa-circle-info"></i>
                                        </label>

                                        <div class="border border-secondary rounded p-2"
                                             style="height: 150px; overflow-y: auto; border-radius: 5px;">
                                            <div id="checkboxContainer"
                                                 *ngFor="let option of clientesList; let i = index"
                                                 class="form-check"
                                                 [ngClass]="{ 'highlight-inte': option.id === usuarioForm.get('id_cliente')?.value}">
                                                <input type="checkbox"
                                                       class="form-check-input"
                                                       [id]="'option' + i"
                                                       [checked]="isSeleccionado(option)"
                                                       [disabled]="isClienteFijo(option) || usuarioForm.get('id_cliente')?.value === ''"
                                                       (change)="onClientesPosiblesChange($event, option)" />
                                                <label class="form-check-label"
                                                       [for]="'option' + i">
                                                    {{ option.nombre }}
                                                </label>
                                            </div>
                                        </div>

                                        <div class="mt-3">
                                            <span *ngFor="let clienteSel of clientes_seleccionados"
                                                  class="badge badge-primary mr-1"
                                                  [ngClass]="{
                                                    'badge-primary': clienteSel.id !== usuarioForm.get('id_cliente')?.value,
                                                    'badge-warning': clienteSel.id === usuarioForm.get('id_cliente')?.value
                                                  }">
                                                {{ clienteSel.nombre }}
                                            </span>
                                        </div>

                                        <div *ngIf="enviado && f['clientes_seleccionados'].errors"
                                             class="form-control-feedback">
                                            <div *ngIf="usuarioForm.get('clientes_seleccionados')?.errors?.['apiError']">{{
                                                usuarioForm.get('clientes_seleccionados')?.errors?.['apiError'] }}</div>
                                        </div>

                                    </div>



                                </div>



                            </div> <!-- row INTRANET cliente-->

                        </div> <!-- card-body -->
                    </div> <!-- card -->




                    <!-- Usuario con rol usuario, datos de PDA -->

                    <div *ngIf="usuarioForm.get('rol')?.value === 'usuario'"
                         class="card border border-secondary rounded intranetCard">
                        <div class="card-body ">
                            <h4 class="card-title"><i class="fa-solid fa-key"></i> Accesos PDA</h4>


                            <!-- swRecogidas -->
                            <div class="row">
                                <div class="col-auto">
                                    <div class="form-group mb-0"
                                         [ngClass]="{ 'has-danger': enviado && f['swRecogidas'].errors }">
                                        <div class="custom-control custom-switch">
                                            <input formControlName="swRecogidas"
                                                   type="checkbox"
                                                   class="custom-control-input"
                                                   id="swRecogidas">
                                            <label class="custom-control-label"
                                                   for="swRecogidas"> ¿Puede hacer recogidas desde Pda?</label>
                                        </div>
                                        <div *ngIf="enviado && f['swRecogidas'].errors"
                                             class="form-control-feedback">
                                            <div *ngIf="usuarioForm.get('swRecogidas')?.errors?.['apiError']">{{
                                                usuarioForm.get('swRecogidas')?.errors?.['apiError'] }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <span class="text-muted"> El usuario verá en la lista de opciones de la PDA la opción de Recogidas</span>
                                </div>
                            </div>



                            <!-- swPreparaciones -->
                            <div class="row">
                                <div class="col-auto">
                                    <div class="form-group mb-0"
                                         [ngClass]="{ 'has-danger': enviado && f['swPreparaciones'].errors }">
                                        <div class="custom-control custom-switch">
                                            <input formControlName="swPreparaciones"
                                                   type="checkbox"
                                                   class="custom-control-input"
                                                   id="swPreparaciones">
                                            <label class="custom-control-label"
                                                   for="swPreparaciones"> ¿Puede hacer preparaciones desde Pda?</label>
                                        </div>
                                        <div *ngIf="enviado && f['swPreparaciones'].errors"
                                             class="form-control-feedback">
                                            <div *ngIf="usuarioForm.get('swPreparaciones')?.errors?.['apiError']">{{
                                                usuarioForm.get('swPreparaciones')?.errors?.['apiError'] }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <span class="text-muted"> El usuario verá en la lista de opciones de la PDA la opción de Preparaciones</span>
                                </div>
                            </div>

                            <hr>

                            <!-- swEntradasPendientes -->
                            <div class="row">
                                <div class="col-auto">
                                    <div class="form-group mb-0"
                                         [ngClass]="{ 'has-danger': enviado && f['swEntradasPendientes'].errors }">
                                        <div class="custom-control custom-switch">
                                            <input formControlName="swEntradasPendientes"
                                                   type="checkbox"
                                                   class="custom-control-input"
                                                   id="swEntradasPendientes">
                                            <label class="custom-control-label"
                                                   for="swEntradasPendientes"> ¿Puede gestionar entradas pendientes?</label>
                                        </div>
                                        <div *ngIf="enviado && f['swEntradasPendientes'].errors"
                                             class="form-control-feedback">
                                            <div *ngIf="usuarioForm.get('swEntradasPendientes')?.errors?.['apiError']">{{
                                                usuarioForm.get('swEntradasPendientes')?.errors?.['apiError'] }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <span class="text-muted"> El usuario verá en la lista de opciones de la PDA la opción de Entradas pendientes. Se mostrará la lista de TODAS las entradas pendientes que tengan activado el Sw 'swEditPda' = 1</span>
                                </div>
                            </div>


                            <!-- swEntradasDirectas -->
                            <div class="row">
                                <div class="col-auto">
                                    <div class="form-group mb-0"
                                         [ngClass]="{ 'has-danger': enviado && f['swEntradasDirectas'].errors }">
                                        <div class="custom-control custom-switch">
                                            <input formControlName="swEntradasDirectas"
                                                   type="checkbox"
                                                   class="custom-control-input"
                                                   id="swEntradasDirectas">
                                            <label class="custom-control-label"
                                                   for="swEntradasDirectas"> ¿Puede gestionar entradas directas?</label>
                                        </div>
                                        <div *ngIf="enviado && f['swEntradasDirectas'].errors"
                                             class="form-control-feedback">
                                            <div *ngIf="usuarioForm.get('swEntradasDirectas')?.errors?.['apiError']">{{
                                                usuarioForm.get('swEntradasDirectas')?.errors?.['apiError'] }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <span class="text-muted"> <i class="fa-solid fa-truck-ramp-box mr-2"
                                           title="Entrada DIRECTA Pda"></i> El usuario podrá crear y gestionar entradas directas a Stock.</span>
                                </div>
                            </div>


                            <!-- swEntradasValidar -->
                            <div class="row">
                                <div class="col-auto">
                                    <div class="form-group mb-0"
                                         [ngClass]="{ 'has-danger': enviado && f['swEntradasValidar'].errors }">
                                        <div class="custom-control custom-switch">
                                            <input formControlName="swEntradasValidar"
                                                   type="checkbox"
                                                   class="custom-control-input"
                                                   id="swEntradasValidar">
                                            <label class="custom-control-label"
                                                   for="swEntradasValidar"> ¿Puede validar entradas?</label>
                                        </div>
                                        <div *ngIf="enviado && f['swEntradasValidar'].errors"
                                             class="form-control-feedback">
                                            <div *ngIf="usuarioForm.get('swEntradasValidar')?.errors?.['apiError']">{{
                                                usuarioForm.get('swEntradasValidar')?.errors?.['apiError'] }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <span class="text-muted"> El usuario podrá validar las entradas, estas quedarán confirmadas físicamente una vez validadas</span>
                                </div>
                            </div>

                            <hr>


                            <!-- swEmbalajes -->
                            <div class="row">
                                <div class="col-auto">
                                    <div class="form-group mb-0"
                                         [ngClass]="{ 'has-danger': enviado && f['swEmbalajes'].errors }">
                                        <div class="custom-control custom-switch">
                                            <input formControlName="swEmbalajes"
                                                   type="checkbox"
                                                   class="custom-control-input"
                                                   id="swEmbalajes">
                                            <label class="custom-control-label"
                                                   for="swEmbalajes"> ¿Puede gestionar embalajes?</label>
                                        </div>
                                        <div *ngIf="enviado && f['swEmbalajes'].errors"
                                             class="form-control-feedback">
                                            <div *ngIf="usuarioForm.get('swEmbalajes')?.errors?.['apiError']">{{
                                                usuarioForm.get('swEmbalajes')?.errors?.['apiError'] }}</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col">
                                    <span class="text-muted"> El usuario podrá gestionar la cantidad de embalajes para los envíos. Estos se tendrán en cuenta en los periodos de facturación al cliente.</span>
                                </div>
                            </div>


                        </div> <!-- card-body -->
                    </div> <!-- card -->




                    <!-- USUARIO NO CLIENTE -->


                    <div class="row"
                         *ngIf="usuarioForm.get('rol')?.value !== 'cliente'">

                        <!-- dir_export_DTX -->
                        <div class="col-md-4">
                            <div class="form-group"
                                 [ngClass]="{ 'has-danger': enviado && f['dir_export_DTX'].errors }">
                                <label class="form-control-label">Carpeta Exportación de envíos (xls DTX)</label>
                                <input type="text"
                                       formControlName="dir_export_DTX"
                                       class="form-control"
                                       [ngClass]="{ 'form-control-danger': enviado && f['dir_export_DTX'].errors }">
                                <div *ngIf="enviado && f['dir_export_DTX'].errors"
                                     class="form-control-feedback">
                                    <div *ngIf="f['dir_export_DTX'].errors['required']">Obligatorio</div>
                                    <div *ngIf="usuarioForm.get('dir_export_DTX')?.errors?.['apiError']">{{usuarioForm.get('dir_export_DTX')?.errors?.['apiError'] }}</div>
                                </div>
                            </div>
                        </div>



                        <!-- id_prnLaser -->
                        <div class="col-md-4">
                            <div class="form-group"
                                 [ngClass]="{ 'has-danger': enviado && f['id_prnLaser'].errors }">
                                <label class="form-control-label">Impresora Laser</label>
                                <div class="input-group">
                                    <div class="input-group-addon"> <i class="fa-solid fa-print"></i></div>

                                    <select formControlName="id_prnLaser"
                                            class="form-control"
                                            [ngClass]="{ 'form-control-danger': enviado && f['id_prnLaser'].errors }">
                                        <option value="">Selecciona...</option>
                                        <option *ngFor="let prn of prnLaserList"
                                                [value]="prn.id">
                                            {{prn.nombre}}
                                        </option>
                                    </select>
                                </div>
                                <div *ngIf="enviado && f['id_prnLaser'].errors"
                                     class="form-control-feedback">
                                    <div *ngIf="f['id_prnLaser'].errors['required']">Obligatorio</div>
                                    <div *ngIf="usuarioForm.get('id_prnLaser')?.errors?.['apiError']">{{
                                        usuarioForm.get('id_prnLaser')?.errors?.['apiError'] }}</div>
                                </div>
                            </div>
                        </div>



                        <!-- id_prnEtiquetas -->
                        <div class="col-md-4">
                            <div class="form-group"
                                 [ngClass]="{ 'has-danger': enviado && f['id_prnEtiquetas'].errors }">
                                <label class="form-control-label">Etiquetadora</label>
                                <div class="input-group">
                                    <div class="input-group-addon"> <i class="fa-regular fa-note-sticky"></i></div>

                                    <select formControlName="id_prnEtiquetas"
                                            class="form-control"
                                            [ngClass]="{ 'form-control-danger': enviado && f['id_prnEtiquetas'].errors }">
                                        <option value="">Selecciona...</option>
                                        <option *ngFor="let prn of prnEtiqList"
                                                [value]="prn.id">
                                            {{prn.nombre}}
                                        </option>
                                    </select>
                                </div>
                                <div *ngIf="enviado && f['id_prnEtiquetas'].errors"
                                     class="form-control-feedback">
                                    <div *ngIf="f['id_prnEtiquetas'].errors['required']">Obligatorio</div>
                                    <div *ngIf="usuarioForm.get('id_prnEtiquetas')?.errors?.['apiError']">{{
                                        usuarioForm.get('id_prnEtiquetas')?.errors?.['apiError'] }}</div>
                                </div>
                            </div>
                        </div>


                    </div> <!-- row -->



                    <div class="d-flex">
                        <button *ngIf="volver_a"
                                [disabled]="loading"
                                type="button"
                                class="btn waves-effect waves-light btn-rounded btn-secondary"
                                [routerLink]="volver_a"
                                data-dismiss="modal">Cancelar</button>
                        <h6 *ngIf="paramId !== 'new'"
                            class="card-subtitle ml-4 ">
                            <li *ngIf="usuarioSrv.userdata.created_at"> Creado hace {{usuarioSrv.userdata.created_at! | friendlyDdmmyy}}</li>
                            <li *ngIf="usuarioSrv.userdata.updated_at"> Última modificación hace {{usuarioSrv.userdata.updated_at! | friendlyDdmmyy}}</li>
                        </h6>
                        <button [disabled]="loading"
                                type="submit"
                                class="ml-auto btn waves-effect waves-light btn-rounded btn-success">
                            <i *ngIf="loading"
                               class="fa fa-spinner fa-spin"></i>
                            Enviar</button>
                    </div>

                </form>
            </div>
        </div>
    </div>

</div>